import { Container, BigBoldText } from "../fall-analysis/form/sharedImports";
import CaregiverAuditForm from "./form/CaregiverAuditForm";
import { useCaregiverAuditForm } from "./useCaregiverAuditForm";

// Caregiver Audit param modal (MARCC-773). Facility + date range + optional
// incident-type/caregiver filters; on Generate it navigates to the standalone
// report via handleFormSubmit.
const CaregiverAudit = ({ handleCloseModal, title, handleFormSubmit }: any) => {
  const {
    facilityOptions,
    isFetching,
    setFieldValue,
    handleSubmit,
    values,
    isSubmitDisabled,
    incidentTypeOptions,
    onIncidentTypeChange,
    caregiverOptions,
    caregiversLoading,
    onCaregiverChange,
  } = useCaregiverAuditForm({ submitFn: handleFormSubmit });

  return (
    <Container>
      <div className="mb-7">
        <button
          type="button"
          onClick={() => handleCloseModal()}
          className="cursor-pointer text-4xl font-medium"
          style={{ backgroundColor: "transparent", border: "0" }}
        >
          &times;
        </button>
        <div className="flex-1 text-center">
          <BigBoldText>{title}</BigBoldText>
        </div>
      </div>

      <CaregiverAuditForm
        formName="caregiverAuditForm"
        handleSubmit={handleSubmit}
        facilityOptions={facilityOptions}
        setFieldValue={setFieldValue}
        values={values}
        closeFn={handleCloseModal}
        isSubmitDisabled={isSubmitDisabled}
        isFetching={isFetching}
        bottom={false}
        incidentTypeOptions={incidentTypeOptions}
        onIncidentTypeChange={onIncidentTypeChange}
        caregiverOptions={caregiverOptions}
        caregiversLoading={caregiversLoading}
        onCaregiverChange={onCaregiverChange}
      />
    </Container>
  );
};

export default CaregiverAudit;
